import Register from "../../public/register";
const RegisterCustomers = () => {
    return (
        <div className="customer-registration-container">
            <Register isForServiceProvider={true} />
        </div>
    );
};

export default RegisterCustomers;